import {createReducer, on} from "@ngrx/store";
import {initialPatternGroupState, PatternGroupState} from "./pattern-group.state";
import {PatternGroupActions} from "./pattern-group.actions";

export const patternGroupReducer = createReducer<PatternGroupState>(
    initialPatternGroupState,

    on(PatternGroupActions.loadAll, (state): PatternGroupState => ({
        ...state,
        groups: {...state.groups, status: "LOADING"},
    })),
    on(PatternGroupActions.loadAllSuccess, (state, {groups}): PatternGroupState => ({
        ...state,
        groups: {data: groups, status: "LOADED", errorMessage: ""},
    })),
    on(PatternGroupActions.loadAllError, (state, {errorMsg}): PatternGroupState => ({
        ...state,
        groups: {data: [], status: "ERROR", errorMessage: errorMsg},
    })),

    on(PatternGroupActions.load, (state): PatternGroupState => ({
        ...state,
        selectedGroup: {...state.selectedGroup, status: "LOADING"},
    })),
    on(PatternGroupActions.loadSuccess, (state, {group}): PatternGroupState => ({
        ...state,
        selectedGroup: {data: group, status: "LOADED", errorMessage: ""},
    })),
    on(PatternGroupActions.loadError, (state, {errorMsg}): PatternGroupState => ({
        ...state,
        selectedGroup: {data: null, status: "ERROR", errorMessage: errorMsg},
    })),

    on(PatternGroupActions.save, (state): PatternGroupState => ({
        ...state,
        selectedGroup: {...state.selectedGroup, status: "LOADING"},
    })),
    on(PatternGroupActions.saveSuccess, (state, {group}): PatternGroupState => ({
        ...state,
        selectedGroup: {data: group, status: "SAVED", errorMessage: ""},
    })),
    on(PatternGroupActions.saveError, (state, {errorMsg}): PatternGroupState => ({
        ...state,
        selectedGroup: {...state.selectedGroup, status: "ERROR", errorMessage: errorMsg},
    })),

    on(PatternGroupActions.updateFilterQuery, (state, {filterQuery}): PatternGroupState => ({
        ...state,
        groupFilterQuery: filterQuery,
    })),

    on(PatternGroupActions.reset, (): PatternGroupState => initialPatternGroupState),
);
